import { Protocol } from '../Protocol';

export class SourcesProtocol {
  public static readonly SOURCES_URL: string = `${Protocol.YATUNG_API_ROOT}/source`; // 更新 & 新增來源

  public static readonly ALL_SOURCES: string = `${Protocol.YATUNG_API_ROOT}/source/all`;
}
